export const productTypeToName = (productType: string): string => {
  switch (productType) {
  case 'vail':
    return 'Vail';
  case 'osw':
    return 'OSW';
  case 'storcycle':
    return 'Storcycle';
  default:
    return 'Unknown Product Type';
  }
};
